import { plainToClass } from 'class-transformer'
import Response from '@/utils/response'
import Answer from '@/models/answer'
import Theme from '@/models/theme'
import mPageLoading from '@/mixins/page-loading'
import mPageTitle from '@/mixins/page-title'
import mPagination from '@/mixins/pagination'
import DonutChart from '@/components/chart/DonutChart'
import Pagination from '@/components/Pagination'

const DEFAULT_PER_PAGE = 15

export default {
  components: {
    DonutChart,
    Pagination
  },
  mixins: [
    mPageLoading,
    mPageTitle,
    mPagination
  ],
  title () {
    return this.$t("pages.user.answers.index.title")
  },
  props: {
    repository: Object,
    theme_id: Number
  },
  data: () => ({
    theme: new Theme,
    answers: [],
    defaultPerPage: DEFAULT_PER_PAGE,
  }),
  watch: {
    theme (value) {
      if (value.viewable_result)
        this.$store.commit('setBackRoute', {
          name: 'theme-show',
          params: { id: value.id },
        })
      else
        this.$store.commit('setBackRoute', {
          name: 'root'
        })
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.get(this.theme_id, {
          params: this.pageParams()
        }))
        this.answers = plainToClass(Answer, response.result)
        this.theme = plainToClass(Theme, response.meta.theme)
        this.pagination.totalCount = response.pageInfo.total_count
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    pageChange (num) {
      this.pagination.page = num
      this.fetchData()
    },
    show (answer) {
      this.$router.push({
        name: 'answer-show',
        params: { id: answer.id },
        query: { from: this.$route.path },
      })
    },
  },
}
